import { MEDIA_TYPE, VIDEO_TYPE } from '../base/media/constants';
/** Local camera attachment and renderer evidence; this does not prove remote reception. */
export function isHandoffVideoReady(state, roomName) {
    const { conference, joining, leaving, room } = state['features/base/conference'];
    const video = state['features/base/tracks'].find(track => track.local
        && track.mediaType === MEDIA_TYPE.VIDEO && track.videoType !== VIDEO_TYPE.DESKTOP);
    if (!conference || conference === leaving || (joining && joining !== conference)
        || room !== roomName || !video?.jitsiTrack || video.muted || video.videoStarted !== true) {
        return false;
    }
    try {
        return conference.getName().toLowerCase() === roomName.toLowerCase()
            && conference.getLocalTracks().includes(video.jitsiTrack)
            && video.jitsiTrack.isMuted() === false
            && video.jitsiTrack.isReceivingData() === true;
    }
    catch {
        // A disposed conference/track cannot authorize releasing the source.
        return false;
    }
}
/** Observe an already-acquired target camera even when the user hides self-view. */
export function getHandoffProbeVideo(state) {
    const handoff = state['features/device-handoff'];
    const { conference, room } = state['features/base/conference'];
    if (!handoff?.handoffInProgress || handoff.progress?.stage !== 'establishing'
        || !conference || !room || handoff.receivedRoomName !== room) {
        return undefined;
    }
    return state['features/base/tracks'].find(track => track.local
        && track.mediaType === MEDIA_TYPE.VIDEO && track.videoType !== VIDEO_TYPE.DESKTOP
        && track.jitsiTrack && !track.muted && !track.videoStarted);
}
